export const formatPrice = (price: number, currency: string) => {
  return price.toLocaleString('en', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0
  })
}
